import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/app.css';
import BackToTop from 'vue-backtotop';
import './assets/css/highlight-custom.css';

createApp(App)
	.use(router)
	.use(BackToTop)
	.mount('#app');
